import * as models from "./api/models";
import isLookupAppKey from "./isLookupAppKey";
import {InputValidation, isValidDate} from "./validateApplicationField";

const EMPTY_ARR: string[] = [];
const NOT_FOUND_VALIDATION = {isValid: true, messages: EMPTY_ARR, validationKey: null};

const REQUIRED_INPUTS = [models.LookupAppKeys.SsnLast4, models.LookupAppKeys.DateOfBirth];

const strings = {
    required: "Value is required.",
    invalidFormat: "is not a valid value.",
    ssFormat: "Social Security should be 4 numbers long.",
    dateFormat: "Dates should be in the MM/DD/YYYY format.",
};

const REGEX = {
    birthDate: /^(0[1-9]|1[0-2])\/(0[1-9]|1\d|2\d|3[01])\/(19|20)\d{2}$/,
    socialSecurity: "^([0-9]{4})",
};

export default function validateLookupAppField(
    name: models.LookupAppKeys,
    value: string,
): InputValidation {
    const validationKey = name;
    if (!isLookupAppKey(name)) {
        return NOT_FOUND_VALIDATION;
    }

    const validation = {
        isValid: true,
        messages: EMPTY_ARR,
        validationKey,
    };

    if (REQUIRED_INPUTS.find((reqdName) => name === reqdName)) {
        if (typeof value === "string" && !value) {
            validation.isValid = false;
            validation.messages = [...validation.messages, strings.required];
        }
    }

    if (name === models.LookupAppKeys.SsnLast4 && typeof value === "string" && !!value) {
        const invalid = !value.match(REGEX.socialSecurity);
        if (invalid) {
            validation.isValid = false;
            validation.messages = [
                ...validation.messages,
                `"${value}" ${strings.invalidFormat}`,
                strings.ssFormat,
            ];
        }
    }

    if (name === models.LookupAppKeys.DateOfBirth && typeof value === "string" && !!value) {
        const invalid = !value.match(REGEX.birthDate) || !isValidDate(value);
        if (invalid) {
            validation.isValid = false;
            validation.messages = [
                ...validation.messages,
                `"${value}" ${strings.invalidFormat}`,
                !isValidDate(value) ? "" : strings.dateFormat,
            ];
        }
    }

    return validation;
}
